import { render, staticRenderFns } from "./MtcLabDashboard.vue?vue&type=template&id=da6dec60&scoped=true&"
import script from "./MtcLabDashboard.vue?vue&type=script&lang=js&"
export * from "./MtcLabDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MtcLabDashboard.vue?vue&type=style&index=0&id=da6dec60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6dec60",
  null
  
)

export default component.exports